export const Terms = ({ language }) => {
  if (language === 'es') {
    return (
      <section className="standard">
        <h1>
          Los Términos y Condiciones de Uso son efectivos a partir del 01 de Julio de 2022.
        </h1>

        <h2>1. Términos</h2>

        <p>
          Al acceder a este sitio web, accesible desde https://edworking.com/, usted acepta
          estar sujeto a estos Términos y Condiciones de Uso del sitio web y acepta que es
          responsable del cumplimiento de cualquier ley local aplicable. Si no está de acuerdo
          con alguno de estos términos, queda prohibido el acceso a este sitio. Los materiales
          contenidos en este sitio web están protegidos por la ley de derechos de autor y marca
          registrada.
        </p>

        <h2>2. Licencia de Uso</h2>

        <p>
          Se otorga permiso para descargar temporalmente una copia de los materiales del sitio
          web de Edworking Ltd para su visualización personal, no comercial y transitoria
          solamente. Esta es una concesión de licencia, no una transferencia de título, y bajo
          esta licencia no podrá:
        </p>

        <ul>
          <li>modificar o copiar los materiales;</li>
          <li>
            utilizar los materiales con cualquier propósito comercial o para cualquier
            exhibición pública;
          </li>
          <li>
            intentar ingeniería inversa de cualquier software contenido en el sitio web de
            Edworking Ltd;
          </li>
          <li>
            eliminar cualquier notación de derechos de autor u otras notaciones de propiedad de
            los materiales; o
          </li>
          <li>
            transferir los materiales a otra persona o "reflejar" los materiales en cualquier
            otro servidor.
          </li>
        </ul>

        <p>
          Esto permitirá a Edworking Ltd terminar por violaciones de cualquiera de estas
          restricciones. Al finalizar, también se terminará su derecho de visualización y debe
          destruir cualquier material descargado en su posesión, ya sea en formato impreso o
          electrónico. Estos Términos de Servicio han sido creados con la ayuda del Generador
          de Términos de Servicio.
        </p>

        <h2>3. Descargo de Responsabilidad</h2>

        <p>
          Todos los materiales en el sitio web de Edworking Ltd se proporcionan "tal cual".
          Edworking Ltd no ofrece garantías, ya sean expresas o implícitas, por lo tanto, niega
          todas las demás garantías. Además, Edworking Ltd no hace ninguna representación sobre
          la exactitud o confiabilidad del uso de los materiales en su sitio web o en relación
          con dichos materiales o cualquier sitio vinculado a este sitio web.
        </p>

        <h2>4. Limitaciones</h2>

        <p>
          Edworking Ltd o sus proveedores no serán responsables de ningún daño que surja del
          uso o la imposibilidad de usar los materiales en el sitio web de Edworking Ltd,
          incluso si Edworking Ltd o un representante autorizado de este sitio web ha sido
          notificado, oralmente o por escrito, de la posibilidad de dicho daño. Algunas
          jurisdicciones no permiten limitaciones de garantías implícitas o limitaciones de
          responsabilidad por daños incidentales, por lo que estas limitaciones pueden no
          aplicarse a usted.
        </p>

        <h2>5. Revisiones y Erratas</h2>

        <p>
          Los materiales que aparecen en el sitio web de Edworking Ltd pueden incluir errores
          técnicos, tipográficos o fotográficos. Edworking Ltd no promete que ninguno de los
          materiales en este sitio web sea preciso, completo o actual. Edworking Ltd puede
          cambiar los materiales contenidos en su sitio web en cualquier momento y sin previo
          aviso. Edworking Ltd no se compromete a actualizar los materiales.
        </p>

        <h2>6. Enlaces</h2>

        <p>
          Edworking Ltd no ha revisado todos los sitios enlazados a su sitio web y no es
          responsable del contenido de ningún sitio enlazado. La presencia de cualquier enlace
          no implica la aprobación del sitio por parte de Edworking Ltd. El uso de cualquier
          sitio web enlazado es bajo el propio riesgo del usuario.
        </p>

        <h2>7. Modificaciones de los términos y condiciones de uso del sitio</h2>

        <p>
          Edworking Ltd puede revisar estos Términos de uso de su sitio web en cualquier
          momento sin previo aviso. Al utilizar este sitio web, aceptas estar sujeto a la
          versión actual de estos Términos y condiciones de uso.
        </p>

        <h2>8. Tu privacidad</h2>

        <p>Por favor, lee nuestra Política de privacidad.</p>

        <h2>9. Ley aplicable</h2>

        <p>
          Cualquier reclamo relacionado con el sitio web de Edworking Ltd estará regido por las
          leyes de GB sin tener en cuenta sus disposiciones de conflicto de leyes.
        </p>
      </section>
    )
  } else if (language === 'pt') {
    return (
      <section className="standard">
        <h1>Termos e Condições de Uso são efetivos a partir de 01 de julho de 2022.</h1>

        <h2>1. Termos</h2>

        <p>
          Ao acessar este site, acessível em https://edworking.com/, você concorda em ficar
          vinculado a estes Termos e Condições de Uso do site e concorda que é responsável pelo
          cumprimento de todas as leis locais aplicáveis. Se você não concorda com qualquer um
          destes termos, está proibido de acessar este site. Os materiais contidos neste site
          são protegidos por direitos autorais e leis de marcas registradas.
        </p>

        <h2>2. Licença de Uso</h2>

        <p>
          Permissão é concedida para baixar temporariamente uma cópia dos materiais do site da
          Edworking Ltda para visualização pessoal, não comercial e transitória apenas. Esta é
          uma concessão de licença, não uma transferência de título, e sob esta licença você
          não pode:
        </p>

        <ul>
          <li>modificar ou copiar os materiais;</li>
          <li>
            usar os materiais para qualquer finalidade comercial ou para qualquer exibição
            pública;
          </li>
          <li>
            tentar engenharia reversa em qualquer software contido no site da Edworking Ltda;
          </li>
          <li>
            remover quaisquer notações de direitos autorais ou outras propriedades dos
            materiais; ou
          </li>
          <li>
            transferir os materiais para outra pessoa ou "espelhar" os materiais em qualquer
            outro servidor.
          </li>
        </ul>

        <p>
          Isto permitirá que a Edworking Ltda termine em caso de violação de qualquer uma
          dessas restrições. Após a rescisão, seu direito de visualização também será
          rescindido e você deverá destruir todos os materiais baixados em sua posse, seja em
          formato impresso ou eletrônico. Estes Termos de Serviço foram criados com a ajuda do
          Gerador de Termos de Serviço.
        </p>

        <h2>3. Aviso Legal</h2>

        <p>
          Todos os materiais no site da Edworking Ltda são fornecidos "como estão". A Edworking
          Ltda não oferece garantias, expressas ou implícitas, e nega todas as outras
          garantias. Além disso, a Edworking Ltda não faz nenhuma representação sobre a
          precisão ou confiabilidade do uso dos materiais em seu site ou de outra forma
          relacionados a esses materiais ou a quaisquer sites vinculados a este site.
        </p>

        <h2>4. Limitações</h2>

        <p>
          A Edworking Ltda ou seus fornecedores não serão responsáveis por quaisquer danos que
          possam surgir com o uso ou incapacidade de uso dos materiais no site da Edworking
          Ltda, mesmo que a Edworking Ltda ou um representante autorizado deste site tenha sido
          notificado, oralmente ou por escrito, da possibilidade de tais danos. Algumas
          jurisdições não permitem limitações em garantias implícitas ou limitações de
          responsabilidade por danos incidentais, essas limitações podem não se aplicar a você.
        </p>

        <h2>5. Revisões e Erratas</h2>

        <p>
          Os materiais que aparecem no site da Edworking Ltd podem incluir erros técnicos,
          tipográficos ou fotográficos. A Edworking Ltd não promete que qualquer um dos
          materiais neste site seja preciso, completo ou atual. A Edworking Ltd pode mudar os
          materiais contidos em seu site a qualquer momento, sem aviso prévio. A Edworking Ltd
          não faz nenhum compromisso em atualizar os materiais.
        </p>

        <h2>6. Links</h2>

        <p>
          A Edworking Ltd não revisou todos os sites vinculados ao seu site e não é responsável
          pelo conteúdo de nenhum site vinculado. A presença de qualquer link não implica
          endosso pela Edworking Ltd do site. O uso de qualquer site vinculado é por conta e
          risco do usuário.
        </p>

        <h2>7. Modificações nos Termos de Uso do Site</h2>

        <p>
          A Edworking Ltd pode revisar estes Termos de Uso para seu site a qualquer momento,
          sem aviso prévio. Ao utilizar este site, você concorda em ficar vinculado à versão
          atual desses Termos e Condições de Uso.
        </p>

        <h2>8. Sua Privacidade</h2>

        <p>Por favor, leia nossa Política de Privacidade.</p>

        <h2>9. Lei Aplicável</h2>

        <p>
          Qualquer reclamação relacionada ao site da Edworking Ltd será regida pelas leis do
          Reino Unido sem levar em consideração suas disposições de conflito de leis.
        </p>
      </section>
    )
  } else if (language === 'fr') {
    return (
      <section className="standard">
        <h1>Les conditions d'utilisation sont en vigueur à partir du 1er juillet 2022.</h1>

        <h2>1. Termes</h2>

        <p>
          En accédant à ce site Web, accessible depuis https://edworking.com/, vous acceptez
          d'être lié par ces Conditions d'utilisation du site Web et vous acceptez d'être
          responsable de l'accord avec toutes les lois locales applicables. Si vous n'êtes pas
          d'accord avec l'un de ces termes, vous êtes interdit d'accéder à ce site. Les
          matériaux contenus dans ce site Web sont protégés par le droit d'auteur et la loi sur
          les marques de commerce.
        </p>

        <h2>2. Licence d'utilisation</h2>

        <p>
          Permission est accordée de télécharger temporairement une copie des matériaux sur le
          site Web d'Edworking Ltd pour une visualisation personnelle, non commerciale et
          transitoire uniquement. Il s'agit d'une licence, pas d'un transfert de titre, et en
          vertu de cette licence, vous ne pouvez pas :
        </p>

        <ul>
          <li>modifier ou copier les matériaux;</li>
          <li>
            utiliser les matériaux à des fins commerciales ou pour toute exposition publique;
          </li>
          <li>tenter de décompiler tout logiciel contenu sur le site Web d'Edworking Ltd;</li>
          <li>
            supprimer tout droit d'auteur ou autre mention de propriété des matériaux; ou
          </li>
          <li>
            transférer les matériaux à une autre personne ou « miroir » les matériaux sur tout
            autre serveur.
          </li>
        </ul>

        <p>
          Cela permettra à Edworking Ltd de mettre fin à toute violation de ces restrictions.
          En cas de résiliation, votre droit de visualisation sera également résilié et vous
          devrez détruire tout matériel téléchargé en votre possession, qu'il soit imprimé ou
          sous forme électronique. Ces conditions d'utilisation ont été créées à l'aide du
          générateur de conditions d'utilisation.
        </p>

        <h2>3. Avertissement</h2>

        <p>
          Tous les matériaux sur le site Web d'Edworking Ltd sont fournis « tels quels ».
          Edworking Ltd ne donne aucune garantie, qu'elle soit expresse ou implicite, et exclut
          toutes les autres garanties. En outre, Edworking Ltd ne fait aucune déclaration quant
          à l'exactitude ou à la fiabilité de l'utilisation des matériaux sur son site Web ou
          en relation avec ces matériaux ou tout site lié à ce site Web.
        </p>

        <h2>4. Limitations</h2>

        <p>
          Edworking Ltd ou ses fournisseurs ne seront pas tenus responsables de tout dommage
          qui résulterait de l'utilisation ou de l'impossibilité d'utiliser les matériaux sur
          le site Web d'Edworking Ltd, même si Edworking Ltd ou un représentant autorisé de ce
          site Web a été informé, verbalement ou par écrit, de la possibilité de tels dommages.
          Certaines juridictions n'autorisent pas les limitations de garanties implicites ou
          les limitations de responsabilité pour les dommages indirects, ces limitations
          peuvent donc ne pas s'appliquer à vous.
        </p>

        <h2>5. Révisions et Errata</h2>

        <p>
          Les matériaux figurant sur le site web d'Edworking Ltd peuvent comporter des erreurs
          techniques, typographiques ou photographiques. Edworking Ltd ne garantit pas que les
          matériaux de ce site web sont exacts, complets ou à jour. Edworking Ltd peut modifier
          les matériaux contenus sur son site web à tout moment et sans préavis. Edworking Ltd
          ne s'engage pas à mettre à jour les matériaux.
        </p>

        <h2>6. Liens</h2>

        <p>
          Edworking Ltd n'a pas examiné tous les sites liés à son site web et n'est pas
          responsable du contenu de ces sites liés. La présence d'un lien n'implique pas
          l'approbation par Edworking Ltd du site. L'utilisation de tout site web lié se fait
          aux risques et périls de l'utilisateur.
        </p>

        <h2>7. Modifications des Conditions d'utilisation du site</h2>

        <p>
          Edworking Ltd peut réviser ces Conditions d'utilisation de son site web à tout moment
          et sans préavis. En utilisant ce site web, vous acceptez d'être lié par la version
          actuelle de ces Conditions d'utilisation.
        </p>

        <h2>8. Votre vie privée</h2>

        <p>Veuillez lire notre Politique de confidentialité.</p>

        <h2>9. Loi applicable</h2>

        <p>
          Toute réclamation liée au site web d'Edworking Ltd sera régie par les lois de gb,
          sans tenir compte de ses dispositions en matière de conflit de lois.
        </p>
      </section>
    )
  } else if (language === 'de') {
    return (
      <section className="standard">
        <h1>Nutzungsbedingungen sind ab dem 01. Juli 2022 wirksam.</h1>

        <h2>1. Bedingungen</h2>

        <p>
          Durch den Zugriff auf diese Website, die über https://edworking.com/ erreichbar ist,
          stimmen Sie diesen Nutzungsbedingungen für die Website zu und erklären sich damit
          einverstanden, dass Sie für die Einhaltung aller geltenden lokalen Gesetze
          verantwortlich sind. Wenn Sie mit einer dieser Bedingungen nicht einverstanden sind,
          ist Ihnen der Zugriff auf diese Website untersagt. Die auf dieser Website enthaltenen
          Materialien sind durch das Urheberrecht und das Markenrecht geschützt.
        </p>

        <h2>2. Nutzungsrechte</h2>

        <p>
          Es ist gestattet, vorübergehend eine Kopie der Materialien auf der Website von
          Edworking Ltd für den persönlichen, nicht kommerziellen und vorübergehenden Gebrauch
          herunterzuladen. Dies ist die Gewährung einer Lizenz, nicht der Übertragung von
          Eigentumsrechten, und unter dieser Lizenz dürfen Sie Folgendes nicht tun:
        </p>

        <ul>
          <li>die Materialien verändern oder kopieren;</li>
          <li>
            die Materialien für kommerzielle Zwecke oder für eine öffentliche Darstellung
            verwenden;
          </li>
          <li>versuchen, Software auf der Website von Edworking Ltd zurückzuentwickeln;</li>
          <li>
            alle Urheberrechts- oder anderen Eigentumshinweise aus den Materialien entfernen;
            oder
          </li>
          <li>
            die Materialien an eine andere Person übertragen oder die Materialien auf einem
            anderen Server "spiegeln".
          </li>
        </ul>

        <p>
          Dies berechtigt Edworking Ltd zur Kündigung bei Verstößen gegen eine dieser
          Einschränkungen. Nach Beendigung wird Ihr Betrachtungsrecht ebenfalls beendet und Sie
          sollten alle heruntergeladenen Materialien, unabhängig davon, ob sie in gedruckter
          oder elektronischer Form vorliegen, vernichten. Diese Nutzungsbedingungen wurden mit
          Hilfe des Terms Of Service Generator erstellt.
        </p>

        <h2>3. Haftungsausschluss</h2>

        <p>
          Alle Materialien auf der Website von Edworking Ltd werden "wie besehen" zur Verfügung
          gestellt. Edworking Ltd gibt keine Garantien, sei es ausdrücklich oder
          stillschweigend, und negiert daher alle anderen Garantien. Darüber hinaus macht
          Edworking Ltd keine Zusicherungen hinsichtlich der Genauigkeit oder Zuverlässigkeit
          der Verwendung der Materialien auf seiner Website oder anderweitig in Bezug auf
          solche Materialien oder Websites, die mit dieser Website verlinkt sind.
        </p>

        <h2>4. Einschränkungen</h2>

        <p>
          Edworking Ltd oder seine Lieferanten haften nicht für Schäden, die durch die Nutzung
          oder Unmöglichkeit der Nutzung der Materialien auf der Website von Edworking Ltd
          entstehen, auch wenn Edworking Ltd oder ein bevollmächtigter Vertreter dieser Website
          mündlich oder schriftlich auf die Möglichkeit solcher Schäden hingewiesen wurde.
          Einige Gerichtsbarkeiten lassen Einschränkungen von stillschweigenden Garantien oder
          Haftungsbeschränkungen für zufällige Schäden nicht zu, daher gelten diese
          Einschränkungen möglicherweise nicht für Sie.
        </p>

        <h2>5. Überarbeitungen und Fehler</h2>

        <p>
          Die auf der Website von Edworking Ltd angezeigten Materialien können technische,
          typografische oder fotografische Fehler enthalten. Edworking Ltd kann nicht
          garantieren, dass alle Materialien auf dieser Website korrekt, vollständig oder
          aktuell sind. Edworking Ltd kann die auf seiner Website enthaltenen Materialien
          jederzeit ohne Vorankündigung ändern. Edworking Ltd verpflichtet sich nicht zur
          Aktualisierung der Materialien.
        </p>

        <h2>6. Links</h2>

        <p>
          Edworking Ltd hat nicht alle mit seiner Website verknüpften Websites überprüft und
          ist nicht für den Inhalt einer solchen verknüpften Website verantwortlich. Die
          Anwesenheit eines Links impliziert keine Unterstützung durch Edworking Ltd für die
          Website. Die Nutzung einer verknüpften Website erfolgt auf eigene Gefahr des
          Benutzers.
        </p>

        <h2>7. Änderungen der Nutzungsbedingungen der Website</h2>

        <p>
          Edworking Ltd kann diese Nutzungsbedingungen für seine Website jederzeit und ohne
          vorherige Ankündigung ändern. Durch die Nutzung dieser Website erklären Sie sich mit
          der aktuellen Version dieser Nutzungsbedingungen einverstanden.
        </p>

        <h2>8. Ihre Privatsphäre</h2>

        <p>Bitte lesen Sie unsere Datenschutzrichtlinie.</p>

        <h2>9. Anwendbares Recht</h2>

        <p>
          Jede Anspruch im Zusammenhang mit der Website von Edworking Ltd unterliegt den
          Gesetzen von gb, ohne Berücksichtigung seiner kollisionsrechtlichen Bestimmungen.
        </p>
      </section>
    )
  } else if (language === 'it') {
    return (
      <section className="standard">
        <h1>Termini e condizioni d'uso in vigore dal 01 luglio 2022.</h1>

        <h2>1. Termini</h2>

        <p>
          Accedendo a questo sito web, accessibile dal sito https://edworking.com/, l'utente
          accetta di essere vincolato dai presenti Termini e condizioni d'uso del sito web e
          accetta di essere responsabile dell'accordo con qualsiasi legge locale applicabile.
          Se non siete d'accordo con uno qualsiasi di questi termini, vi è vietato accedere a
          questo sito. I materiali contenuti in questo sito web sono protetti dalle leggi sul
          diritto d'autore e sui marchi.
        </p>

        <h2>2. Licenza d'uso</h2>

        <p>
          È concessa la licenza di scaricare temporaneamente una copia dei materiali presenti
          sul sito web di Edworking Ltd&apos;solo per uso personale e transitorio non
          commerciale. Questa è la concessione di una licenza, non un trasferimento di
          proprietà, e in base a questa licenza non è possibile:
        </p>

        <ul>
          <li>modificare o copiare il materiale; </li>
          <li>
            utilizzare i materiali per qualsiasi scopo commerciale o per qualsiasi esposizione
            pubblica;
          </li>
          <li>tentare di decodificare i materiali per mezzo di un'ingegneria inversa</li>
          <li>
            tentare di decodificare qualsiasi software contenuto nel sito web di Edworking
            Ltd&apos;
          </li>
          .
          <li>
            rimuovere qualsiasi copyright o altre notazioni proprietarie dai materiali; o
          </li>
          <li>
            trasferire i materiali a un'altra persona o &quot;rispecchiare&quot;i materiali su
            qualsiasi altro server.
          </li>
        </ul>

        <p>
          Questo consentirà a Edworking Ltd di interrompere il servizio in caso di violazione
          di una qualsiasi di queste restrizioni. In caso di risoluzione, anche il diritto di
          visualizzazione sarà interrotto e l'utente dovrà distruggere qualsiasi materiale
          scaricato in suo possesso, sia in formato cartaceo che elettronico. I presenti
          Termini di servizio sono stati creati con l'aiuto del Generatore di Termini di
          servizio.
        </p>

        <h2>3. Disclaimer</h2>

        <p>
          Tutti i materiali presenti sul sito web di Edworking Ltd sono forniti &quot;così come
          sono&quot;. Edworking Ltd non fornisce alcuna garanzia, sia essa espressa o
          implicita, e pertanto nega ogni altra garanzia. Inoltre, Edworking Ltd non rilascia
          alcuna dichiarazione in merito all'accuratezza o all'affidabilità dell'uso dei
          materiali presenti sul proprio sito web o altrimenti relativi a tali materiali o a
          qualsiasi sito collegato a questo sito web.
        </p>

        <h2>4. Limitazioni</h2>

        <p>
          Edworking Ltd o i suoi fornitori non saranno ritenuti responsabili per eventuali
          danni che deriveranno dall'uso o dall'impossibilità di usare i materiali presenti sul
          sito web di Edworking Ltd, anche se Edworking Ltd o un rappresentante autorizzato di
          questo sito web è stato avvisato, oralmente o per iscritto, della possibilità di tali
          danni. Alcune giurisdizioni non ammettono limitazioni alle garanzie implicite o
          limitazioni di responsabilità per danni accidentali; queste limitazioni potrebbero
          non essere applicabili all'utente.
        </p>

        <h2>5. Revisioni ed errori</h2>

        <p>
          I materiali presenti sul sito web di Edworking Ltd possono contenere errori tecnici,
          tipografici o fotografici. Edworking Ltd non garantisce che i materiali contenuti nel
          sito web siano accurati, completi o aggiornati. Edworking Ltd può modificare i
          materiali contenuti nel proprio sito web in qualsiasi momento e senza preavviso.
          Edworking Ltd non si impegna ad aggiornare i materiali.
        </p>

        <h2>6. Collegamenti</h2>

        <p>
          Edworking Ltd non ha esaminato tutti i siti collegati al suo sito web e non è
          responsabile dei contenuti di tali siti collegati. La presenza di un qualsiasi link
          non implica l'approvazione del sito da parte di Edworking Ltd. L'uso di qualsiasi
          sito web collegato è a rischio dell'utente.
        </p>

        <h2>7. Modifiche alle condizioni d'uso del sito</h2>

        <p>
          Edworking Ltd può rivedere le presenti Condizioni d'uso del sito web in qualsiasi
          momento senza preavviso. Utilizzando questo sito web, l'utente accetta di essere
          vincolato dalla versione corrente di questi Termini e condizioni d'uso.
        </p>

        <h2>8. La vostra privacy</h2>

        <p>Leggere la nostra Informativa sulla privacy.</p>

        <h2>9. Legge applicabile</h2>

        <p>
          Qualsiasi reclamo relativo al sito web di Edworking Ltd&apos;è regolato dalle leggi
          della Gran Bretagna, senza tener conto del conflitto di leggi.
        </p>
      </section>
    )
  } else {
    return (
      <section className="standard">
        <h1>Terms and Conditions of Use are effective as of July 01, 2022.</h1>

        <h2>1. Terms</h2>

        <p>
          By accessing this Website, accessible from https://edworking.com/, you are agreeing
          to be bound by these Website Terms and Conditions of Use and agree that you are
          responsible for the agreement with any applicable local laws. If you disagree with
          any of these terms, you are prohibited from accessing this site. The materials
          contained in this Website are protected by copyright and trade mark law.
        </p>

        <h2>2. Use License</h2>

        <p>
          Permission is granted to temporarily download one copy of the materials on Edworking
          Ltd&apos;s Website for personal, non-commercial transitory viewing only. This is the
          grant of a license, not a transfer of title, and under this license you may not:
        </p>

        <ul>
          <li>modify or copy the materials;</li>
          <li>use the materials for any commercial purpose or for any public display;</li>
          <li>
            attempt to reverse engineer any software contained on Edworking Ltd&apos;s Website;
          </li>
          <li>remove any copyright or other proprietary notations from the materials; or</li>
          <li>
            transferring the materials to another person or &quot;mirror&quot; the materials on
            any other server.
          </li>
        </ul>

        <p>
          This will let Edworking Ltd to terminate upon violations of any of these
          restrictions. Upon termination, your viewing right will also be terminated and you
          should destroy any downloaded materials in your possession whether it is printed or
          electronic format. These Terms of Service has been created with the help of the Terms
          Of Service Generator.
        </p>

        <h2>3. Disclaimer</h2>

        <p>
          All the materials on Edworking Ltd’s Website are provided &quot;as is&quot;.
          Edworking Ltd makes no warranties, may it be expressed or implied, therefore negates
          all other warranties. Furthermore, Edworking Ltd does not make any representations
          concerning the accuracy or reliability of the use of the materials on its Website or
          otherwise relating to such materials or any sites linked to this Website.
        </p>

        <h2>4. Limitations</h2>

        <p>
          Edworking Ltd or its suppliers will not be hold accountable for any damages that will
          arise with the use or inability to use the materials on Edworking Ltd’s Website, even
          if Edworking Ltd or an authorize representative of this Website has been notified,
          orally or written, of the possibility of such damage. Some jurisdiction does not
          allow limitations on implied warranties or limitations of liability for incidental
          damages, these limitations may not apply to you.
        </p>

        <h2>5. Revisions and Errata</h2>

        <p>
          The materials appearing on Edworking Ltd’s Website may include technical,
          typographical, or photographic errors. Edworking Ltd will not promise that any of the
          materials in this Website are accurate, complete, or current. Edworking Ltd may
          change the materials contained on its Website at any time without notice. Edworking
          Ltd does not make any commitment to update the materials.
        </p>

        <h2>6. Links</h2>

        <p>
          Edworking Ltd has not reviewed all of the sites linked to its Website and is not
          responsible for the contents of any such linked site. The presence of any link does
          not imply endorsement by Edworking Ltd of the site. The use of any linked website is
          at the user’s own risk.
        </p>

        <h2>7. Site Terms of Use Modifications</h2>

        <p>
          Edworking Ltd may revise these Terms of Use for its Website at any time without prior
          notice. By using this Website, you are agreeing to be bound by the current version of
          these Terms and Conditions of Use.
        </p>

        <h2>8. Your Privacy</h2>

        <p>Please read our Privacy Policy.</p>

        <h2>9. Governing Law</h2>

        <p>
          Any claim related to Edworking Ltd&apos;s Website shall be governed by the laws of gb
          without regards to its conflict of law provisions.
        </p>
      </section>
    )
  }
}
